

module.exports = __webpack_require__.stylable.create(
    "GroupGridCard583802956",
    {"classes":{"root":"GroupGridCard583802956__root","info":"GroupGridCard583802956__info","gridCardMeta":"GroupGridCard583802956__gridCardMeta"},"vars":{},"stVars":{"borderWidth":"\"applyUnit(fallback(zeroAsTrue(--cardBorderWidth), 1), px)\"","borderColor":"\"fallback(--cardBorderColor, color(color-3))\"","topBottomPadding":"\"applyUnit(fallback(zeroAsTrue(--groupCardGridTopBottomSpacing), 20), px)\"","sidePadding":"\"applyUnit(fallback(zeroAsTrue(--groupCardGridSideSpacing), 20), px)\"","backgroundColor":"\"fallback(--cardBackgroundColor, color-1)\""},"keyframes":{}},
    "",
    2,
    "GroupGridCard583802956",
    null
);
